module.exports = {
  builderAPIKey: "ecfa7c798ce749ba8f29db2c0e200db0",
}
